document.querySelectorAll('[data-infinite-scroll]').forEach((sentinel) => {
  let loading = false;

  const grids = () => sentinel.closest('#CollectionProductGrid').querySelectorAll('.js-infinite-grid');
  const targetGrid = () => {
    const list = grids();
    return list.length ? list[list.length - 1] : null;
  };

  const loadNext = () => {
    const nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl || loading) return;
    loading = true;
    sentinel.classList.add('is-loading');

    fetch(nextUrl)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sourceGrids = doc.querySelectorAll('.js-infinite-grid');
        const target = targetGrid();

        if (target && sourceGrids.length) {
          const sourceItems = sourceGrids[sourceGrids.length - 1].children;
          Array.from(sourceItems).forEach((item) => {
            target.appendChild(item);
          });
        }

        const nextSentinel = doc.querySelector('[data-infinite-scroll]');
        const newNextUrl = nextSentinel ? nextSentinel.getAttribute('data-next-url') : '';

        if (newNextUrl) {
          sentinel.setAttribute('data-next-url', newNextUrl);
        } else {
          sentinel.removeAttribute('data-next-url');
          observer.unobserve(sentinel);
        }
      })
      .finally(() => {
        loading = false;
        sentinel.classList.remove('is-loading');
      });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) loadNext();
    });
  }, { rootMargin: '600px 0px' });

  if (sentinel.getAttribute('data-next-url')) {
    observer.observe(sentinel);
  }
});
